import { Score } from "./Score";
import { capitalizeFirstLetter, formatPrice } from "../utils/utils";
import Quartiles from "../model/Quartiles";

interface ProductProps {
  url_image: string;
  url_product: string;
  name: string;
  brand: string;
  category: string;
  price: number;
  score: number;
  quartiles: Quartiles;
  isGlobal: boolean;
  setIsGlobal: React.Dispatch<React.SetStateAction<boolean>>;
  dynamicPrice: string | number;
}

export default function Product(props: ProductProps) {
  return (
    <div className="row-span-1 col-span-2 xl:col-span-1 rounded-xl p-6 box-border bg-blackOverlay dark:bg-whiteOverlay flex flex-col md:flex-row md:items-start gap-6">
      <img
        src={props.url_image}
        alt="product"
        className="rounded-lg m-auto w-[220px] h-[220px] md:w-[35vh] md:h-[35vh] xl:h-full object-cover"
      />
      <div className="flex flex-col justify-between w-full box-border h-[220px] md:h-[35vh] xl:h-full">
        <div className="flex items-start justify-between gap-2">
          <div className="h-full xl:w-2/3 2xl:w-auto">
            <a
              className="group relative xl:w-1/2 2xl:w-4/6 text-2xl md:text-3xl short:text-2xl xshort:text-lg font-semibold underline"
              rel="noreferrer"
              href={props.url_product}
              target="_blank"
            >
              <p className="line-clamp-1">
                {capitalizeFirstLetter(props.name)}
              </p>

              <div className="hidden group-hover:block absolute bottom-5 w-max p-2 z-10 transition-all duration-500 rounded-xl bg-blackLight dark:bg-whiteLight shadow-lg">
                <p className="text-white dark:text-black text-xs font-normal">
                  {capitalizeFirstLetter(props.name)}
                </p>
              </div>
            </a>
            <p className="text-xl w-min md:text-2xl short:text-xl xshort:text-base italic text-darkLight dark:text-whiteLight text-center md:text-start">
              {capitalizeFirstLetter(props.brand)}
            </p>
            <p className="whitespace-nowrap text-lg w-min md:text-xl short:text-lg xshort:text-sm text-center md:text-start">
              {formatPrice(
                props.dynamicPrice !== 0 ? props.dynamicPrice : props.price
              )}
            </p>
          </div>
          <div className="group relative xl:w-2/3 2xl:w-auto">
            <select
              className="text-black dark:text-white bg-white dark:bg-black md:text-base text-sm py-2 px-4 rounded-lg mr-2 xl:w-full 2xl:w-auto"
              value={props.isGlobal ? "toutes catégories" : props.category}
              onChange={(e) => props.setIsGlobal(e.target.value === "global")}
            >
              <option value={"global"}>{"toutes catégories"}</option>
              <option value={props.category}>{props.category}</option>
            </select>
            <div className="hidden group-hover:block absolute bottom-9 right-0 p-2 w-56 z-10 transition-all duration-500 rounded-md bg-blackLight dark:bg-whiteLight shadow-lg">
              <p className="text-white dark:text-black text-xs ">
                Possibilité de visualiser le score soit au global, soit selon la
                catégorie du produit
              </p>
            </div>
          </div>
        </div>
        <Score
          score={props.score}
          quartiles={props.quartiles}
          isGlobal={props.isGlobal}
          category={props.category}
        />
      </div>
    </div>
  );
}
